import {
  SearchBar,
  // FeaturedCard,
  DietList,
  ColorButton,
} from "components/diet/";
import React, { useEffect, useState } from "react";
import client from "helpers/sanity";
import { useCallback } from "react";
import DietCard from "components/diet/DietCard";
import { categoriesQuery } from "constants/queries";

const Diet = () => {
  const [category, setCategory] = useState("");
  const [searchResult, setSearchResult] = useState([]);

  // search result
  const handleResult = useCallback((data) => {
    setSearchResult(data);
  }, []);

  //category
  const handleCategory = useCallback((category) => {
    setCategory(category);
  }, []);

  return (
    <div className="bg-gray-50 w-full h-auto py-6 sm:py-10 md:py-20 flex flex-col items-center justify-center md:px-6">
      <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 text-center">
        A blog template made <br /> for food{" "}
        <span className="text-orange-500">influencer's</span>
      </h1>
      <SearchBar handleResult={handleResult} />
      <CategoryButtons handleCategory={handleCategory} />
      {searchResult.length > 0 ? (
        <SearchResults data={searchResult} />
      ) : (
        <DietList category={category} />
      )}
    </div>
  );
};

const SearchResults = ({ data }) => {
  return (
    <div className="flex flex-wrap justify-center my-[2rem] w-full">
      {data.map((data, index) => (
        <div key={index} className="w-1/2 md:w-1/3 lg:w-1/4">
          <DietCard data={data} />
        </div>
      ))}
    </div>
  );
};

const CategoryButtons = ({ handleCategory }) => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    client.fetch(categoriesQuery()).then((data) => setCategories(data));
  }, []);

  return (
    <div className="mt-8 flex flex-wrap justify-center gap-2 sm:gap-3 md:gap-4">
      {categories.map((category, index) => (
        <div
          key={category.title}
          onClick={() => handleCategory(category.title)}
        >
          <ColorButton title={category.title} colorIndex={index} />
        </div>
      ))}
    </div>
  );
};

export default Diet;
